// extracted by mini-css-extract-plugin
export default {"apple-pay-button":"style_apple-pay-button__iRJUr","apple-pay-button-animation":"style_apple-pay-button-animation__WQ4zH","applePayShine":"style_applePayShine__s6jeL"};